import React from 'react'
import './Footer.scss'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer__container--bar'></div>
        <div className='footer__container'>
            
            <div className='footer__container__content'>
            <p className='footer__container__content__description'>
            Copyright 2024 © Tech Bizz Club, M.L.V.T.E.C.</p>
            <p className='footer__container__content__description--highlight'>All images used in this website are property of Tech Bizz Club, M.L.V.T.E.C.</p>
            
            </div>
        </div>
    </div>
  )
}

export default Footer